module.exports = "/_next/static/images/bh-0dc78a04794c407895e93acc6b428292.svg";